export function limitItems(array, limit = 5) {
  if (!Array.isArray(array)) {
    throw new TypeError('Expected an array');
  }

  if (typeof limit !== 'number' || limit < 0) {
    throw new TypeError('Limit must be a non-negative number');
  }

  const visible = array.slice(0, limit);
  const hidden = array.slice(limit);

  const tooltipItems = hidden.map((item) => String(item));
  const summary = hidden.length > 0 ? `and ${hidden.length} other${hidden.length > 1 ? 's' : ''}` : '';

  return {
    visible,
    hidden,
    summary,
    tooltipItems,
  };
}
